/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceControlFilter {
    getFixupPrototypeFunction() { return ComplianceControlFilter.fixupPrototype; }

    static newInstance(model: Partial<ComplianceControlFilter>): ComplianceControlFilter {
        let obj = Object.assign(new ComplianceControlFilter(), model);
        ComplianceControlFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceControlFilter>): ComplianceControlFilter {
        if (!model) return null;
        return ComplianceControlFilter.newInstance(<ComplianceControlFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceControlFilter) {
        if (!obj) return;

        models.ComplianceControlFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceControlFilter): boolean {
        Object.setPrototypeOf(obj, ComplianceControlFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.query) {
            models.QueryOperator.fixupPrototype(this.query);
        }
    }

    /**
     * Tenant ID
     */
    tenant_id: string;

    /**
     * Unique ID for the compliance standard
     */
    compliance_standard_id: string;

    /**
     * Search on severity, nature
     */
    search: string;

    /**
     * Query on nature, severity, family, sub_family and policy_uri
     */
    query: models.QueryOperator;

}
